
<div class="overlay-container" >
</div> 
<div class="modal show" id="myModal" style="padding-right: 16px; ">
 <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">

        <div id="addorUpdat" class="mt-4 mb-4">Renewal Reminders?</div>
            <div class="row no-margin">
                <div class="col-12 col-sm-12 mb-3">
                  For future renewals, would you like to receive a reminder 14 days before the registrations expire?
                </div>
                  
                
              
                  
                        <div class="col-12 col-sm-12 mb-3 mt-4">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto addressChangeBtn"  (click)="yes()" >Yes</button>
                            </a>
                     </div>  
                        <div class="col-12 col-sm-12 mb-3">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto addressChangeBtn" (click)="no()">No
</button>
                            </a>
                     </div> 
              </div>          
        </div>

    </div>
  </div>
</div>
